const HELPER_TEXT = {
  instructions: {
    title: 'IMPORTANTE',
    message:
      'Para finalizar la orden de recepción con productos faltantes debes tener en cuenta las siguiente consideraciones: ',
    arrayOfInstructions: [
      'La orden se finalizará solo con los productos y cantidades que previamente almacenaste',
      'A continuación, deja un comentario para cada producto con cantidad faltante'
    ]
  }
};

export default HELPER_TEXT;
